import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=745f64fe&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editor.vue?vue&type=style&index=1&id=745f64fe&lang=scss&scoped=true&"
import style2 from "./editor.vue?vue&type=style&index=2&id=745f64fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f64fe",
  null
  
)

export default component.exports